import React from "react";

const TextInput = ({ label, name, value, onChange, placeholder, type = "text", error, ...props }) => {

    return (
        <div className="user-input-container">
            <label htmlFor={name}>{label}</label>
            <input
                type={type}
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={error ? "error" : ""}
                // disabled={disabled} // Just use props
                // readOnly={readOnly} // Just use props
                {...props}
            />
            {error && <span className="error-text">{error}</span>}
        </div>
    );
};

const SelectInput = ({ label, name, value, onChange, options, error, ...props }) => {
    return (
        <div className="user-input-container">
            <label htmlFor={name}>{label}</label>
            <div className="select-wrapper">
                <select
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    className={error ? "error" : value === "" ? "placeholder-select-text" : ""}
                    // readOnly={readOnly} // Just use props
                    // disabled={disabled} // Just use props
                    {...props}
                >
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
            {error && <span className="error-text">{error}</span>}

        </div>
    );
};


export { TextInput, SelectInput };
